import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/news/[slug]/components/MainBannerNews.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/news/[slug]/components/NewsMain.jsx");
